import {
    Col,
    Container, DropdownItem, DropdownMenu, DropdownToggle,
    Nav,
    Navbar,
    NavItem,
    NavLink,
    Row,
    UncontrolledCollapse,
    UncontrolledDropdown
} from "reactstrap";
import {Link} from "react-router-dom";
import forensicImg from "../../assets/img/forensic.jpg";
import argonReactImg from "../../assets/img/brand/argon-react.png";
import {DATA} from "../../index";

const AlcoholCalcNavbar = () =>{
    return (
    <>
      <Navbar className="navbar-main navbar-expand-sm navbar-transparent py-2" expand="md"
        style={{ boxShadow : "0 15px 35px rgba(50,50,93,.1)"}}>
        <Container>
          <Link className="navbar-brand mr-lg-5" to="/" onClick={() => {window.location.assign('/')}}>
            <img src={forensicImg} style={{width: '3vh', height: '3vh'}} alt="Forensic"/>
          </Link>

          <a className="link-black" href={"/alcohol-calcs"}>Alcohol Calculator</a>

          <button className="navbar-toggler" id="navbar-collapse-main">
            <span className="navbar-toggler-icon"/>
          </button>
          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/">
                    <img
                        alt="..."
                        src={argonReactImg}
                    />
                  </Link>
                </Col>
              </Row>
            </div>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
};

export  default AlcoholCalcNavbar;